import { flowRight } from 'lodash';
import { connect } from 'react-redux';

import {
  getIsBlogMenuEnabled,
  getIsBlogMenuCategoryLabelsEnabled,
  getIsBlogMenuSearchEnabled,
  getIsBlogMenuLoginButtonEnabled,
  getIsMobileDisplaySettingsEnabled,
} from '../selectors/app-settings-selectors';
import { getIsMobile } from '@wix/communities-blog-client-common/dist/src/selectors/search-params-selectors';
import withHocName from './with-hoc-name';

const mapStateToProps = state => {
  const useMobileSettings = getIsMobile(state) && getIsMobileDisplaySettingsEnabled(state);
  return {
    showBlogMenu: getIsBlogMenuEnabled(state, useMobileSettings),
    showCategoryLabels: getIsBlogMenuCategoryLabelsEnabled(state, useMobileSettings),
    showSearch: getIsBlogMenuSearchEnabled(state, useMobileSettings),
    showLoginButton: getIsBlogMenuLoginButtonEnabled(state, useMobileSettings),
  };
};

export default flowRight(
  connect(mapStateToProps),
  withHocName('WithBlogMenuSettings'),
);
